import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/shared/lib/cn';

const textareaVariants = cva(
  'flex w-full text-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        outline:
          'rounded-md border border-input bg-background px-3 py-2 shadow-sm focus-visible:ring-2 focus-visible:ring-ring',
        filled:
          'rounded-lg border border-transparent bg-secondary px-4 py-3 text-[15px] shadow-none focus-visible:border-ring focus-visible:bg-background focus-visible:ring-2 focus-visible:ring-ring/40',
      },
    },
    defaultVariants: { variant: 'outline' },
  },
);

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> &
  VariantProps<typeof textareaVariants>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, variant, rows = 3, ...props }, ref) => (
    <textarea
      ref={ref}
      rows={rows}
      className={cn(textareaVariants({ variant }), 'min-h-[80px] resize-y', className)}
      {...props}
    />
  ),
);
Textarea.displayName = 'Textarea';
